import React from 'react'
import Layout from './Layout'

const ActivateUser = () => {
    return (
        <Layout></Layout>
    )
}

export default ActivateUser